module.exports = __webpack_public_path__ + "img/1.bfb4d828.jpg";